import { Component, OnInit, AfterViewInit, ElementRef, ViewChildren } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControlName } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { IMailSurvey } from './MailSurvey';
import { GenericValidator } from '../../shared/generic-validator';
import { AuthService } from '../../auth.service';
import { AppCommonService } from '../../appcommon.service';
import { HomeService } from '../../home/home.service';
import { LoaderService } from '../../LoaderService';
import { Params, ActivatedRoute } from '@angular/router';
declare var $: any;
@Component({
  templateUrl: "./mailsurvey.component.html"
})
export class MailSurveyComponent implements OnInit, AfterViewInit {
  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
  public pageTitle: string = 'Mail Survey';
  surveyForm: FormGroup;
  survey: IMailSurvey;
  // Use with the generic validation message class
  displayMessage: { [key: string]: string } = {};
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;

  constructor(private fb: FormBuilder,
    private authService: AuthService,
    private appCommonService: AppCommonService,
    private activatedRoute: ActivatedRoute,
    public homeService: HomeService,
    public loaderService: LoaderService
  ) {
    this.appCommonService.pageContentAdditionalClass = "home-page login-page";
    this.appCommonService.pageName = this.pageTitle;

    // Defines all of the validation messages for the form.
    // These could instead be retrieved from a file or database.
    this.validationMessages = {
      contactId: {
        required: 'contactId is required.'
      },
      q1: {
        required: 'q1 is required.'
      },
      q2: {
        required: 'q2 is required.'
      },
      q3: {
        required: 'q3 is required.'
      },
      q4: {
        required: 'q4 is required.'
      },
      q5: {
        required: 'q5 is required.'
      },
      q6: {
        required: 'q6 is required.'
      },
      q7: {
        required: 'q7 is required.'
      },
      q8: {
        required: 'q8 is required.'
      },
      q9: {
        required: 'q9 is required.'
      },
      q10: {
        required: 'q10 is required.'
      },
      q11: {
        required: 'q11 is required.'
      },
      comments: {
        required: 'comments is required.'
      }
    };

    // Define an instance of the validator for use with this form, 
    // passing in this form's set of validation messages.
    this.genericValidator = new GenericValidator(this.validationMessages);
  }
  ngOnInit() {
    // subscribe to router event
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let contactId = params['acc'];
      this.surveyForm = this.fb.group({
        contactId: [contactId, [Validators.required]],
        q1: [0, Validators.required],
        q2: [0, Validators.required],
        q3: [0, Validators.required],
        q4: [0, Validators.required],
        q5: [0, Validators.required],
        q6: [0, Validators.required],
        q7: [0, Validators.required],
        q8: [0, Validators.required],
        q9: [0, Validators.required],
        q10: [0, Validators.required],
        q11: [0, Validators.required],
        comments: ['']
      });
    });    
  }

  ngAfterViewInit() {
    this.appCommonService.loadRequiredJS();
    // Watch for the blur event from any input element on the form.
    let controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => Observable.fromEvent(formControl.nativeElement, 'blur'));

    // Merge the blur event observable with the valueChanges observable
    Observable.merge(this.surveyForm.valueChanges, ...controlBlurs).debounceTime(500).subscribe(value => {
      this.displayMessage = this.genericValidator.processMessages(this.surveyForm);
    });
  }

  sendMailSurvey(): void {
    if (this.surveyForm.valid) {
      // Copy the form values over the product object values
      let p = Object.assign({}, this.survey, this.surveyForm.value);
      this.loaderService.display(true);
      this.homeService.sendMailSurvey(p)
        .subscribe(
        () => {          
          this.loaderService.display(false);
          this.homeService.showSuccess("Survey Submitted", "Thank You.");
        },
        (error: any) => {
          this.loaderService.display(false);
          this.homeService.showError("Survey sending problem", <any>error);
        }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/genericpages/mailsurvey/mailsurvey.component.ts